import { Tooltip as ReactTooltip } from 'react-tooltip';
import styled from 'styled-components';

/** @deprecated prefer `import { Tooltip } from '@workramp/ui';` */
function ReactTooltipInfoMarker({
  customStyle,
  src,
  className,
  height,
  width,
  customImgStyle,
  text,
  tooltipId,
  tooltipPlace,
  html,
}) {
  const defaultTooltipId = 'react-tooltip-info-marker';

  return (
    <Wrapper customStyle={customStyle}>
      <img
        src={src || '/images/info_icon.svg'}
        className={className}
        height={height || '12px'}
        width={width || '12px'}
        style={customImgStyle || { position: 'relative', top: '1px' }}
        data-tooltip-content={text}
        data-tooltip-id={tooltipId || defaultTooltipId}
      />
      <ReactTooltip
        id={tooltipId || defaultTooltipId}
        positionStrategy="fixed"
        place={tooltipPlace || 'bottom'}
        html={html || false}
        effect="solid"
      />
    </Wrapper>
  );
}

const Wrapper = styled.span`
  ${(props) => (props.customStyle ? props.customStyle : '')}
`;

export default ReactTooltipInfoMarker;
